import script from "./VTableSubject.vue?vue&type=script&setup=true&lang=js"
export * from "./VTableSubject.vue?vue&type=script&setup=true&lang=js"

import "./VTableSubject.vue?vue&type=style&index=0&id=4f962808&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f962808"]])

export default __exports__